// System
import { Stack } from '@mui/material';

// Components
import { RHFTextField } from '@Components/hook-form';

export const CreateAviatorPermissionContent = () => {
  return (
    <Stack>
      <RHFTextField name="permission" label="Permission" />
    </Stack>
  );
};
